import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/ja_JP";
import { AnnotatedFormItem } from "./AnnotatedFormItem";
import moment from "moment";

export const WeddingDateFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <AnnotatedFormItem
      label="挙式日"
      annotation={
        <>
          内祝い等で、挙式予定がない場合は、
          <br />
          希望利用日をご入力ください
        </>
      }
    >
      <DatePicker
        locale={locale}
        disabledDate={current =>
          current === undefined ? false : current < moment().endOf("day")
        }
        value={store.weddingDate}
        onChange={moment => {
          store.weddingDate = moment === null ? undefined : moment;
        }}
      />
    </AnnotatedFormItem>
  );
});
